import { render } from "./TheTabsBar.vue?vue&type=template&id=04ebc197"
import script from "./TheTabsBar.vue?vue&type=script&lang=ts"
export * from "./TheTabsBar.vue?vue&type=script&lang=ts"
script.render = render

export default script